import { ColDef } from "ag-grid-community";

import { ColumnType } from "components/AgGrid/constants";

export interface NlisHoldingDeviceRow {
  device: NlisHoldingDevice;
  holding: NlisHolding;
}

export const NlisHoldingsColId = {
  NLIS_ID: "2f543afa-7710-4c1e-b243-8ebcffd3cab9",
  EID: "321ccebf-eb09-4f61-a9bd-487b410d4724",
  VENDOR_PIC: "459b4473-a15d-418f-9479-51bba29ce7ac",
  NVD_WAYBILL: "3be2d2d2-330e-44c4-8c0a-671829f5de54",
  SALE_DATE: "e07f40a5-c57c-4930-bec2-ff642c634444",
  SPECIES: "e3433ceb-185a-45ca-a330-71b16a3fc5a6",
  SALEYARD_NAME: "d16b9bbc-d4bc-46e2-b53a-aec2e6552ead",
  HOLDING_STATUS: "09975046-5de6-4083-b14d-c197bd8e4c11",
  HOLDING_LAST_SYNCED: "c41b8561-7232-496c-8f46-55caf99b4a40",
  LAST_MODIFIED: "a9943507-17f7-48d5-ab82-cffba9b099e9",
  CREATED: "dd24f612-6d23-4b83-b229-1a139a33a631",
  DESCRIPTION: "d4cb34e3-6a5e-4f69-9efa-f39a18ca2819",
} as const;

export const NlisHoldingsColumnDefinitions: Record<
  string,
  ColDef<NlisHoldingDeviceRow>
> = {
  [NlisHoldingsColId.NLIS_ID]: {
    headerName: "NLIS ID",
    colId: NlisHoldingsColId.NLIS_ID,
    field: "device.nlisId",
  },
  [NlisHoldingsColId.EID]: {
    headerName: "EID",
    colId: NlisHoldingsColId.EID,
    field: "device.eid",
  },
  [NlisHoldingsColId.VENDOR_PIC]: {
    headerName: "Vendor PIC",
    colId: NlisHoldingsColId.VENDOR_PIC,
    field: "device.vendorPic",
    enableRowGroup: true,
  },
  [NlisHoldingsColId.NVD_WAYBILL]: {
    headerName: "NVD/Waybill",
    colId: NlisHoldingsColId.NVD_WAYBILL,
    field: "device.nvdWaybill",
    enableRowGroup: true,
  },
  [NlisHoldingsColId.SALE_DATE]: {
    headerName: "Sale Date",
    colId: NlisHoldingsColId.SALE_DATE,
    field: "device.saleDate",
    type: ColumnType.DATE,
    enableRowGroup: true,
  },
  [NlisHoldingsColId.SPECIES]: {
    headerName: "Species",
    colId: NlisHoldingsColId.SPECIES,
    field: "device.species",
    enableRowGroup: true,
  },
  [NlisHoldingsColId.SALEYARD_NAME]: {
    headerName: "Saleyard",
    colId: NlisHoldingsColId.SALEYARD_NAME,
    field: "device.saleyardName",
    enableRowGroup: true,
  },
  [NlisHoldingsColId.HOLDING_STATUS]: {
    headerName: "Status",
    colId: NlisHoldingsColId.HOLDING_STATUS,
    field: "holding.status",
    enableRowGroup: true,
  },
  [NlisHoldingsColId.HOLDING_LAST_SYNCED]: {
    headerName: "Last Synced",
    colId: NlisHoldingsColId.HOLDING_LAST_SYNCED,
    field: "holding.lastSynced",
    type: ColumnType.UTC_LOCAL_DATE_TIME,
  },
  [NlisHoldingsColId.LAST_MODIFIED]: {
    headerName: "Last Modified",
    colId: NlisHoldingsColId.LAST_MODIFIED,
    field: "device.lastModified",
    type: ColumnType.UTC_LOCAL_DATE_TIME,
  },
  [NlisHoldingsColId.CREATED]: {
    headerName: "Created",
    colId: NlisHoldingsColId.CREATED,
    field: "device.created",
    type: ColumnType.UTC_LOCAL_DATE_TIME,
  },
  [NlisHoldingsColId.DESCRIPTION]: {
    headerName: "Description",
    colId: NlisHoldingsColId.DESCRIPTION,
    field: "device.description",
  },
};
